module.exports = __webpack_public_path__ + "media/notification_1.841f5ef0.wav";